/**
 * AWARE Health — View Mode Toggle Component
 * Pill toggle switching between Simple and Detailed views.
 */

import { useTranslation } from 'react-i18next'
import { useViewMode } from '../../contexts/ViewModeContext'
import { useTheme } from '../../contexts/ThemeContext'

export default function ViewModeToggle() {
  const { viewMode, toggleViewMode } = useViewMode()
  const { theme } = useTheme()
  const { t } = useTranslation()
  const isDark = theme === 'dark'

  const isSimple = viewMode === 'simple'

  return (
    <button
      onClick={toggleViewMode}
      title={isSimple ? 'Switch to detailed view' : 'Switch to simple view'}
      aria-label={isSimple ? 'Switch to detailed view' : 'Switch to simple view'}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 0,
        padding: 2,
        borderRadius: 20,
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.12)'}`,
        background: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.04)',
        cursor: 'pointer',
        fontSize: 11,
        fontWeight: 600,
        fontFamily: 'Inter, sans-serif',
        transition: 'all 0.2s',
      }}
    >
      <span
        style={{
          padding: '3px 10px',
          borderRadius: 18,
          background: isSimple
            ? (isDark ? 'rgba(20,184,166,0.2)' : '#0d9488')
            : 'transparent',
          color: isSimple
            ? (isDark ? '#5eead4' : '#fff')
            : (isDark ? '#64748b' : '#94a3b8'),
          transition: 'all 0.2s',
          letterSpacing: '0.03em',
        }}
      >
        {t('viewMode.simple')}
      </span>
      <span
        style={{
          padding: '3px 10px',
          borderRadius: 18,
          background: !isSimple
            ? (isDark ? 'rgba(37,99,235,0.2)' : '#2563eb')
            : 'transparent',
          color: !isSimple
            ? (isDark ? '#93c5fd' : '#fff')
            : (isDark ? '#64748b' : '#94a3b8'),
          transition: 'all 0.2s',
          letterSpacing: '0.03em',
        }}
      >
        {t('viewMode.detailed')}
      </span>
    </button>
  )
}
